import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../../common/store/generic.effects';
import {
  WorkLocationAction,
  workLocationActions,
} from './work-location.actions';
import { WorkLocationApiService } from './work-location.api.service';

@Injectable()
export class WorkLocationEffects {
  constructor(
    private readonly workLocationApiService: WorkLocationApiService,
    private readonly action$: Actions<WorkLocationAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    workLocationActions.getById,
    this.workLocationApiService.getById,
  );

  createInstance = createApiCallEffects(
    this,
    this.action$,
    workLocationActions.createInstance,
    this.workLocationApiService.createInstance,
  );

  add = createApiCallEffects(
    this,
    this.action$,
    workLocationActions.add,
    this.workLocationApiService.add,
  );

  update = createApiCallEffects(
    this,
    this.action$,
    workLocationActions.update,
    this.workLocationApiService.update,
  );

  delete = createApiCallEffects(
    this,
    this.action$,
    workLocationActions.delete,
    this.workLocationApiService.delete,
  );
}
